import obtenerConcesiones from "../concesiones/obtener";
import obtenerDirecciones from "../direccion/obtener";
import obtenerHistorialPorConcesion from "../historial/obtenerPorConcesion";
import { toast } from "react-toastify";

import agruparArray from "../../historial/agruparArray";
import obtenerHistorialSinConcesion from "../historial/obtenerSinConcesion";
import expediente from "../../xml/obtenerExpedientePorAutorizacion";

export default async function obtenerContribuyente(idContribuyente, setData) {
    let dataHistorial;
    const endpoint = `/api/contribuyente/ContribuyentePorIdContribuyente/${idContribuyente}`;

    const id = toast.loading("Cargando...");
    try {
        const { data: contribuyente } = await (await fetch(endpoint)).json();
        const concesiones = await obtenerConcesiones(await contribuyente.idContribuyente);
        const direcciones = await obtenerDirecciones(await contribuyente.idContribuyente);

        const idAutorizacion = await concesiones[0]?.idConcesion;

        if (idAutorizacion) {
            const dataWS = await expediente(idAutorizacion);
            concesiones[0].numeroExpediente = await dataWS?.NoExpedienteActual ?? "";
        }

        if (concesiones[0] !== undefined) dataHistorial = await obtenerHistorialPorConcesion(await concesiones[0].idConcesion);
        else dataHistorial = await obtenerHistorialSinConcesion(await contribuyente.idContribuyente);

        const dataObject = {
            contribuyente: contribuyente, concesiones: [...concesiones], direcciones: [...direcciones],
            concesionActual: { ...concesiones[0] }, historial: [...dataHistorial],
            historialArray: [...agruparArray(dataHistorial, 10)]
        }

        setData(dataObject);
        toast.update(id, { render: "Hecho!", type: "success", isLoading: false, autoClose: 500, draggable: true });
        return dataObject;
    }
    catch (_) {
        toast.update(id, {
            render: "Ocurrió un problema con este contribuyente",
            type: "warning", isLoading: false, autoClose: 500, draggable: true
        });
    }
}